import {Box, Link, Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text} from '@chakra-ui/react'
import {useEffect, useMemo, useState} from 'react'
import {useTranslation} from 'next-i18next'
import {Radio} from '_app/components'
import {AvailableShippingMethod} from '_app/types/api'
import {useCheckoutContext} from 'modules/checkout/hooks'
import toast from '_app/utils/toast'
import {INPOST_CARRIER, INPOST_COURIER} from 'modules/checkout/constants'
import ShippingMethodLabel from '_app/components/shared/ShippingMethodLabel'
import ShowroomsSelect from '../ShowroomsSelect'
import LocalStorageHelper from '../../../../helpers/LocalStorageHelper/LocalStorageHelper'
import {useRouter} from '../../../../_app/hooks/useRouter'

type Props = {
    availableShippingMethods: any;
    selectedShippingMethod: any;
    errorMessageInpost: any;
    setValue: any;
    submitForm: () => void;
    loading: boolean;
    cart: any;
};
export const AvailableShippingMethods = ({
                                             availableShippingMethods,
                                             selectedShippingMethod,
                                             setValue,
                                             submitForm,
    cart,
                                         }: Props) => {
    const {t} = useTranslation('checkout')
    const { inpostAddress, setInpostAddress, setInpostAddressDetails } = useCheckoutContext()
    const { locale } = useRouter()
    const [isModalOpen, setIsModalOpen] = useState(false)
    const hideModal = () => {
        setIsModalOpen(false)
    }
    const showModal = () => {
        setIsModalOpen(true)
        openGeoWidgetModal()
    }
    const haveLocaleShippingMethods = availableShippingMethods?.some(
        (shippingMethod: { carrier_code: string }) =>
            shippingMethod?.carrier_code.startsWith('pickup') ||
            shippingMethod?.carrier_code.startsWith(INPOST_CARRIER)
    )

    const haveDeliveryShippingMethods = availableShippingMethods?.some(
        (shippingMethod: { carrier_code: string }) =>
            shippingMethod?.carrier_code.startsWith('flatrate') ||
            shippingMethod?.carrier_code.startsWith('tablerate')
    )
    const finalInpostAddress = useMemo(() => inpostAddress || LocalStorageHelper.get('inpostAddress'), [inpostAddress])
    const getCurrentLocation = (callback: { (latitude: null, longitude: null): () => void; (arg0: number | null, arg1: number | null): void }) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    callback(position.coords.latitude, position.coords.longitude)
                },
                (error) => {
                    console.error('Error fetching location:', error)
                    callback(null, null) // Handle errors or fallback
                }
            )
        } else {
            console.error('Geolocation is not supported by this browser.')
            callback(null, null) // Handle errors or fallback
        }
    }

    const openGeoWidgetModal = () => {
        getCurrentLocation((latitude: null, longitude: null) => {
            const geowidgetElement = document.createElement('inpost-geowidget')
            geowidgetElement.setAttribute('token', process.env.NEXT_PUBLIC_INPOST_PUBLIC_TOKEN || '')
            geowidgetElement.setAttribute('language', 'pl')
            geowidgetElement.setAttribute('config', 'parcelCollect')
            geowidgetElement.setAttribute('onpoint', 'handlePointSelection')

            window.handlePointSelection = (event) => {
                if (event) {
                    const addressLine1 = event.address.line1
                    const addressLine2 = event.address.line2
                    const addressDetails = event.address_details
                    const targetPoint = event.name
                    const locationDescription = event.location_description || ''
                    const openingHours = event.opening_hours || ''
                    const imageUrl = event.image_url || ''
                    setInpostAddress(`${addressLine1} ${addressLine2}`)
                    setInpostAddressDetails({
                        ...addressDetails,
                        location_description: locationDescription,
                        opening_hours: openingHours,
                        image_url: imageUrl,
                    })
                    setValue('shipping_addresses[0].selected_shipping_method.paczkomaty_target_point', targetPoint)
                    setIsModalOpen(false)
                    submitForm()
                } else {
                    toast({
                        description: t('INPOST_MAPS_NOT_LOADED_YET_TRY_AGAIN'),
                    })
                }
            }
            const showMap = setTimeout(() => {
                const container = document.getElementById('geowidget-container')
                if (container) {
                    container.innerHTML = ''
                    container.style.width = '100vw'
                    container.style.height = 'calc(100vh - 62px)'
                    container.appendChild(geowidgetElement)

                    if (longitude && latitude) {
                        geowidgetElement?.addEventListener('inpost.geowidget.init', (event: any) => {
                            const api = event?.detail?.api
                            if (api && latitude !== null && longitude !== null) {
                                api.changePosition({ longitude: longitude, latitude: latitude }, 13)
                            }
                        })
                    }
                }
            }, 500)
            return () => clearTimeout(showMap)
        })
    }
    useEffect(() => {
        if (finalInpostAddress) {
            LocalStorageHelper.set('inpostAdress', finalInpostAddress)
        }
    }, [finalInpostAddress])
    // useEffect(() => {
    //     if (availableShippingMethods?.length > 1 && cart?.cart?.shipping_addresses?.[0]?.country?.code === 'PL') {
    //         setTimeout(() => {
    //             setValue('shipping_addresses[0].selected_shipping_method.carrier_code', 'inpostlocker')
    //         }, 1000)
    //     }
    // }, [cart?.cart?.shipping_addresses?.[0]?.country?.code])
    return (
        <>
            <Box
                display={haveLocaleShippingMethods ? 'block' : 'none'}
                mb={{base: 8, md: 10}}
            >
                <Radio
                    name="shipping_addresses[0].selected_shipping_method.carrier_code"
                    label={t('DELIVERY_TO_PICKUP_POINT', {ns: 'common'})}
                    labelProps={{
                        fontSize: '1rem',
                        fontWeight: 400,
                        mr: 0,
                        mb: 4,
                    }}
                    options={availableShippingMethods
                        .filter(
                            (shippingMethod: any) => {
                                if (!shippingMethod) return false
                                return (
                                    shippingMethod.carrier_code.startsWith('pickup') ||
                                    shippingMethod.carrier_code.startsWith(INPOST_CARRIER)
                                )
                            }
                        )
                        .map((shippingMethod: any) => {
                            return {
                                label: <ShippingMethodLabel method={shippingMethod} method_code={shippingMethod?.method_code} carrier_code={shippingMethod?.carrier_code} />,
                                body: (
                                    <Box>
                                        {shippingMethod.carrier_code === INPOST_CARRIER &&
                                            selectedShippingMethod?.carrier_code ===
                                            INPOST_CARRIER && (
                                                <Box py={4} ml="42px" fontWeight={300}>
                                                    {finalInpostAddress && (
                                                        <Text pb="16px">{finalInpostAddress}</Text>
                                                    )}
                                                    <Link fontWeight={300} onClick={showModal}>
                                                        {inpostAddress
                                                            ? t('CHANGE', {ns: 'common'})
                                                            : t('CHOOSE_PARCEL_LOCKER', {ns: 'common'})}
                                                    </Link>

                                                    {!inpostAddress && (
                                                        <Text
                                                            id="errorMessageInpost"
                                                            color="red"
                                                            fontSize="0.875rem"
                                                            fontWeight={400}
                                                            lineHeight="normal"
                                                            pt="8px"
                                                        >
                                                            Wybierz paczkomat
                                                        </Text>
                                                    )}
                                                </Box>
                                            )}
                                        {shippingMethod.carrier_code === 'pickup' &&
                                            selectedShippingMethod?.carrier_code === 'pickup' && (
                                                <Box py="24px" ml={{base: 'none', md: '40px'}}>
                                                    <ShowroomsSelect cart={cart} />
                                                </Box>
                                            )}
                                    </Box>
                                ),
                                value: shippingMethod.carrier_code,
                            }
                        })}
                />
            </Box>

            <Box display={haveDeliveryShippingMethods ? 'block' : 'none'}>
                <Radio
                    name="shipping_addresses[0].selected_shipping_method.carrier_code"
                    label={t('COURIER_DELIVERY', {ns: 'common'})}
                    labelProps={{
                        fontSize: '1rem',
                        fontWeight: 400,
                        mr: 0,
                        mb: 4,
                    }}
                    defaultValue={availableShippingMethods?.[0]?.value}
                    options={availableShippingMethods
                        .filter(
                            (shippingMethod: any) => {
                                if (!shippingMethod) return false
                                return (
                                    shippingMethod.carrier_code.startsWith('flatrate') ||
                                    shippingMethod.carrier_code.startsWith('tablerate') ||
                                    shippingMethod.carrier_code.startsWith(INPOST_COURIER) && shippingMethod.method_code.startsWith('standardcod')
                                )
                            }
                        )
                        .map((shippingMethod: any) => {
                            return {
                                label: <ShippingMethodLabel method={shippingMethod} method_code={shippingMethod?.method_code} carrier_code={shippingMethod?.carrier_code} />,
                                value: shippingMethod.carrier_code,
                            }
                        })}
                />
            </Box>
            {
                locale === 'pl' && (
                    <Modal isOpen={isModalOpen} onClose={hideModal} size="full">
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader>Wybierz punkt</ModalHeader>
                            <ModalCloseButton />
                            <Box id="geowidget-container" />
                        </ModalContent>
                    </Modal>
                )
            }
        </>
    )
}
